import Reporter from './reporter';
var ReporterFactory;
export function setFactory(factory) {
  ReporterFactory = factory;
}
export function create(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      biLoggerFactory = _ref.biLoggerFactory,
      baseUrl = _ref.baseUrl,
      endpoint = _ref.endpoint,
      preset = _ref.preset,
      useBatch = _ref.useBatch;

  if (!ReporterFactory) {
    return new Reporter({
      biLoggerFactory: biLoggerFactory,
      baseUrl: baseUrl,
      endpoint: endpoint,
      preset: preset,
      useBatch: useBatch
    });
  } else {
    return ReporterFactory({
      preset: preset
    });
  }
}